import { UseMutationOptions } from '@tanstack/react-query';
import { CampaignType, CuredApiPaths, ApiMethods } from 'models/enums';
import useMutation from '../useMutation';
import MutationKeys from './keys';

export type UpdateDraftCampaignMutationInput = {
    name: string;
    type?: CampaignType;
    sends?: any[]; // More flexible for drafts - can handle various send states
    abTestConfig?: any;
    reentryDetails?: any;
    [key: string]: any; // Allow additional properties for flexibility
};

type UpdateDraftCampaignResponse = { id: string };

/**
 * Updates an existing draft campaign using PUT /campaign/draft/:campaignId
 * @param campaignId The ID of the campaign to update
 * @param mutateOptions react-query useMutation option
 * @returns the react-query useMutation results
 * See https://react-query-v3.tanstack.com/reference/useMutation for options and return value
 */
const useUpdateDraftCampaign = (
    campaignId: string,
    mutateOptions?: UseMutationOptions<UpdateDraftCampaignResponse, Error, UpdateDraftCampaignMutationInput>
) =>
    useMutation<UpdateDraftCampaignMutationInput, UpdateDraftCampaignResponse>(
        MutationKeys.UPDATE_DRAFT_CAMPAIGN,
        `${CuredApiPaths.CAMPAIGNS_DRAFT}/${campaignId}`,
        mutateOptions,
        ApiMethods.PUT
    );

export default useUpdateDraftCampaign;
